import React from 'react';
import { Typography } from '@common-ui/ui';
import { useHistory } from 'react-router-dom';

/**
 * Each Tab is a link to the page it is associated with
 * The selected tab is highlighted in yellow
 * While the unselected tab is white
 *
 * @param {string} text - The text displayed in the tab
 * @param {string} path - The path the tab links to
 * @returns {JSX.Element} - A tab
 */

export default function Tab({ text, path }) {
  const history = useHistory();

  const selected = () => history.location.pathname === path;

  const styles = {
    text: {
      ':hover': {
        cursor: 'pointer',
        color: 'black',
        background: 'var(--fluke-yellow)',
        transition: '250ms',
      },
      background: selected() ? 'var(--fluke-yellow)' : 'none',
      color: selected() ? 'black' : 'white',
      paddingY: '18px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      textTransform: 'uppercase',
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
    },
  };

  return (
    <Typography sx={styles.text} onClick={() => history.push({ pathname: path })}>
      {text}
    </Typography>
  );
}
